import React from 'react';

// Rede de segurança em volta das abas carregadas sob demanda (React.lazy).
// Sem ela, um erro ao carregar ou desenhar uma aba (ex.: pedaço de JS apagado
// por um deploy, depois que o lazyWithRetry já recarregou uma vez) deixava a
// tela inteira em branco. Aqui o erro fica contido no lugar da aba, com o
// visual do kit (.ui-vazio + .ui-botao) e um caminho para sair: recarregar.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    console.error('Erro ao abrir a seção:', erro, info?.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    const { titulo = 'Não foi possível abrir esta seção' } = this.props;
    return (
      <div className="ui-card">
        <div className="ui-vazio-bloco" data-area role="alert">
          <p className="ui-vazio">{titulo}</p>
          <p className="ui-vazio__dica">O painel pode ter sido atualizado. Recarregue a página para continuar.</p>
          <button
            type="button"
            className="ui-botao"
            data-variante="fio"
            data-tamanho="sm"
            onClick={() => window.location.reload()}
          >
            Recarregar a página
          </button>
        </div>
      </div>
    );
  }
}
